import { Link } from '@inertiajs/react'
import { AppShell } from '@/components/layout/AppShell'
import { PageHeader } from '@/components/landing/PageHeader'
import { ApplicationsTable, type ApplicationRow } from '@/components/dashboard/ApplicationsTable'
import { Button } from '@/components/ui/button'
import { Plus } from 'lucide-react'

interface Props {
  user: { email: string; role: string }
  organization: { name: string; slug: string }
  applications: ApplicationRow[]
}

export default function Index({ user, organization, applications }: Props) {
  return (
    <AppShell user={user} organization={organization}>
      <div className="space-y-8">
        <PageHeader
          eyebrow="Applications"
          title="Applications"
          description="Manage your API applications and credentials."
          actions={
            <Button asChild>
              <Link href="/dashboard/applications/new">
                <Plus className="mr-2 h-4 w-4" />
                New Application
              </Link>
            </Button>
          }
        />

        <div className="surface-card overflow-hidden">
          <ApplicationsTable data={applications} />
        </div>
      </div>
    </AppShell>
  )
}
